import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncYoutubeMusicToSpotify() {
    return (
        <GuidesPage
            seoData={seoContent.syncYoutubeMusicToSpotify}
            sections={<PairSyncGuideContent sourceKey="youtubeMusic" destKey="spotify" />}
        />
    );
}
